import React, { useEffect, useState } from 'react'

import _ from 'lodash'
import { Button, Form, Modal, Segment, Text, TextArea } from '@wework/dieter-ui'
import Row from '../../Common/Row'
import { withSnackbar } from '../../../hoc/SnackBarProvider'

const HOLD_KEYWORDS_REGEX = /\b(sav(e|ing)|hold|sell|interest|reserv|paperwork|ppw)/i

function OfficeNoteEditModal({
  open,
  handler,
  space,
  floorMap,
  onHoldClick,
  snackBars,
}: any) {
  const [value, setValue] = useState('')
  const [showWarning, setShowWarning] = useState(false)
  const [submittingNote, setSubmittingNote] = useState(false)

  const searchForKeyword = (notes = '') => {
    const showHoldWarning = HOLD_KEYWORDS_REGEX.test(notes)
    setShowWarning(showHoldWarning)
  }

  const debounceSearchForHoldKeywords = _.debounce(
    notesValue => searchForKeyword(notesValue),
    200
  )

  useEffect(() => {
    setValue(space?.reservable?.note)
    return () => {
      setValue('')
    }
  }, [space])

  useEffect(() => {
    debounceSearchForHoldKeywords(value)
  }, [debounceSearchForHoldKeywords, value])

  const handleSubmitNote = async value => {
    if (!floorMap) return

    const occupancyExtension = floorMap.getExtension('reservable')
    if (!occupancyExtension) return

    const reservable = space?.reservable
    if (!reservable) return

    setSubmittingNote(true)

    try {
      await occupancyExtension.updateOfficeNote(reservable.uuid, value.trim())
      snackBars.addAlert({
        text: `Note has been saved.`,
        variant: 'success',
      })
      // this.setState({ submitingNote: false, editingNote: false })
      setSubmittingNote(false)
      if (reservable.note) {
        //   value.trim().length > 0
        //     ? onSuccessUpdateNote({ reservable, notes: value.trim() })
        //     : onSuccessRemoveNote({ reservable })
        // } else {
        //   onSuccessAddNote({ reservable, notes: value.trim() })
      }
    } catch (e) {
      setSubmittingNote(false)
      snackBars.addAlert({
        text: `There was a problem saving your note. Please try again.`,
        variant: 'error',
      })
    }
  }

  return (
    <Modal
      onClose={() => {
        handler(false)
      }}
      onOpen={() => handler(true)}
      open={open}
    >
      <Modal.Header style={{ marginBottom: 8 }}>Add a note</Modal.Header>
      <Text style={{ fontSize: 14 }}>
        For information related to this space.
      </Text>
      <Modal.Content>
        <Form>
          <Form.Field
            control={TextArea}
            label="Note"
            style={{ width: '100%' }}
            // autoComplete="off"
            // autoFocus
            // margin="dense"
            // fluid
            // data-testid="office-note-modal-text"
            id="name"
            value={value}
            // multiline
            fullWidth
            type="text"
            outline
            rows={5}
            //@ts-ignore
            onChange={e => setValue(e.currentTarget.value)}
          />
        </Form>
        {showWarning && (
          <Segment
            style={{
              marginTop: 32,
              backgroundColor: '#F7F7F7',
              padding: 16,
              border: 0,
            }}
          >
            <Row>
              <div>
                <Text style={{ fontWeight: 'bold' }} size="small">
                  ℹ️ Office Holds are now upgraded.
                </Text>
                <Text size="tiny">
                  To hold an office, please avoid using notes and instead put
                  the office on hold. For more information on office hold{' '}
                  <Text
                    primary
                    style={{ cursor: 'pointer', display: 'inline' }}
                    size="tiny"
                    onClick={() =>
                      window.open(
                        'https://connect.weworkers.io/pages/viewpage.action?pageId=162270516',
                        '_blank'
                      )
                    }
                  >
                    visit this page.
                  </Text>
                </Text>
              </div>
              <Button
                primary
                style={{ width: '35%', marginLeft: 16 }}
                basic
                size="small"
                onClick={() => {
                  onHoldClick(true)
                  handler(false)
                }}
              >
                Hold office
              </Button>
            </Row>
          </Segment>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={() => {
            handler(false)
          }}
          default
          size="small"
        >
          Cancel
        </Button>
        <Button
          primary
          disabled={submittingNote}
          loading={submittingNote}
          size="small"
          onClick={() => handleSubmitNote(value).then(() => handler(false))}
        >
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default withSnackbar(OfficeNoteEditModal)
